import React from "react"

const CompanyIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M1 21L21 21" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
            <path d="M17 8L13 8C10.518 8 10 8.518 10 11L10 21H20L20 11C20 8.518 19.482 8 17 8Z" stroke="#2D2D2D" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M14 21L2 21L2 4C2 1.518 2.518 1 5 1L11 1C13.482 1 14 1.518 14 4L14 8" stroke="#2D2D2D" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M2 5L5 5M2 9H5M2 13H5" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
            <path d="M14 12H16M14 15H16" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" />
            <path d="M15 21L15 18" stroke="#2D2D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default CompanyIcon